import { Injectable } from '@angular/core';
import { BaseResolver } from '@app/app.resolver';
import { Asset } from '@app/models/company/asset.model';
import { ModelFactory } from '@app/models/core/model-factory';
import { Company } from '@models/company/company.model';
import { Job } from '@models/company/job.model';
import { Office } from '@models/company/office.model';

@Injectable()
export class CompanyResolver extends BaseResolver {
    protected modelFactory: ModelFactory = new ModelFactory([
        {
            className: 'company',
            production: {
                find: (id: number) => {
                    return Company.find(id);
                },
            },
        },
        {
            className: 'office',
            production: {
                find: (id: number) => {
                    return Office.param('company', this.companyId).find(id);
                },
            },
        },
        {
            className: 'position',
            production: {
                find: (id: number) => {
                    return Job.param('company', this.companyId).find(id);
                },
            },
        },
        {
            className: 'asset',
            production: {
                find: (id: number) => {
                    return Asset.with(['assignment', 'assignment.employee', 'category']).find(id);
                },
            },
        },
    ]);
}
